import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import Instance from './interceptor';

export const getAllSubscriptionPlan = async () => {
  try {
    const response = await Instance.get(`${API.GET_ALL_SUBSCRIPTION_PLAN}`);
    if (response) {
      return response.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const AddSubscriptionPlan = async (formData) => {
  try {
    const response = await Instance.post(
      `${API.ADD_SUBSCRIPTION_PLAN}`,
      formData,
    );
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const deleteSubscriptionPlan = async (Id) => {
  try {
    const response = await Instance.delete(`${API.DELETE_SUBSCRIPTION_PLAN}`, {
      data: { planId: Id },
    });
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};
export const discontinueSubscriptionPlan = async (planId, status) => {
  const payload = {
    planId,
    status,
  };
  try {
    const response = await Instance.put(
      `${API.DISCONTINUE_SUBSCRIPTION_PLAN}`,
      payload,
    );
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const updateSubscriptionPlan = async (formData) => {
  const payload = {
    planId: formData.id, // Ensure 'id' is the field holding the plan ID
    name: formData.name,
    expiry: formData.expiry,
    price: formData.price,
    credits: formData.credits,
    description: formData.description,
  };
  try {
    const response = await Instance.put(
      `${API.UPDATE_SUBSCRIPTION_PLAN}`,
      payload,
    );
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};
